module.exports = __webpack_public_path__ + "static/media/popup.1549a193.jpg";